import styled from 'styled-components'
import { colors } from '@lmc/common/constants'
import { ListItem } from '@lmc/ui-kit'
import { Icon } from '../../../../../components/generic'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { NAMESPACE } from 'locale'
import StockAlertIcon from './StockAlertIcon'
import {
  getShowAlert,
  getStockText,
  getSubLabel
} from '../EMARResidentStockScreenV2/utils'
import { ResidentMedication } from '../types'
import Medication from '../iconsV2/Medication'

type StockListItemProps = {
  label?: string
  medication: ResidentMedication
  residentId: string
}

export const StockListItem = ({
  label,
  medication,
  residentId
}: StockListItemProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const navigate = useNavigate()

  const showAlert = getShowAlert(medication)
  const stockText = getStockText({ medication }, t)
  const subLabel = getSubLabel(medication, t)
  const hasStockInfo = stockText

  const handleClick = () => {
    navigate(
      `/residents/${residentId}/emar/${medication.residentMedicationId}/stock`
    )
  }

  const rightChildren = hasStockInfo ? (
    <RightContent>
      <StockText $showAlert={showAlert}>{stockText}</StockText>
      <StockAlertIcon medication={medication} />
    </RightContent>
  ) : undefined

  return (
    <ListItem
      iconBackgroundColor={colors.informationblue}
      iconContent={<Medication />}
      titleContent={label || medication.medicationName}
      subTitleContent={subLabel || undefined}
      subtitleStyle={{ color: colors.grey }}
      rightChildren={rightChildren}
      onClick={handleClick}
      cursor="pointer"
    />
  )
}

const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const StockText = styled.div<{ $showAlert: boolean }>`
  line-height: 22px;
  color: ${({ $showAlert }) => ($showAlert ? colors.red : colors.black)};
`
